<template>
  <div>
    <MemberTitle member_title="上聯會員卡" member_eng_title="Member Card" />
    <div>
      <div class="profile_card">
        <div>
          <div class="profile_logo ">
            <img src="@/assets/toplink_logo_white.png" alt="Toplink_logo.png">
          </div>
          <div class="profile_number">會員編號 : {{member_info.no}}</div>
          <div class="profile_qrcode">
            <img :src="member_info.no_qrcode_url" alt="">
          </div>
        </div>
      </div>
      <div class="record_btn">
        <router-link to="/member/ticket">查詢報名紀錄</router-link>
      </div>
    </div>
    <BaseFooter/>
  </div>
</template>
<script>
import BaseFooter from '@/components/base/BaseFooter.vue'
import MemberTitle from '@/components/member/MemberTitle'
export default {
  name: 'memberNav',
  components:{
    'BaseFooter': BaseFooter,
    'MemberTitle': MemberTitle,
  },
  data() {
    return {
      member_info: {},
    }
  },
  created() {
    if(this.$cookies.get('member')){
      this.member_info = this.$cookies.get('member')
    }
  },
}
</script>
<style>
  .profile_card{
    width: 360px;
    max-width: 100%;
    margin: 50px auto 30px auto;
    
    text-align: center;
    font-size: 1.2rem;
    color: #fffeee;
  }
  .profile_card>div{
    margin: 10px;
    border-radius: 5%;
    background-color: #275a8a;
  }
  .profile_logo{ padding-top: 15px; }
  .profile_number{
    width: 98%;
    padding: 4px 2px;
    color: #000000;
    background-color: #c5ecec;
    margin: 15px auto;
  }
  .profile_qrcode{
    padding: 15px 0 30px 0;
  }
  .record_btn{
    width: 100%;
    max-width: 360px;
    margin: 40px auto;
    text-align: center;
  }
  .record_btn a{
    background-color: #4ca334;
    color: #eeeeee;
    font-size: 1.3rem;
    line-height: 1.4;
    margin: 10px 5px;
    border-radius: 7px;
    padding: 9px 47px;
    transition: all .3s;
  }
  .record_btn a:hover{
    background-color: #3489a3;
    color: #e4ff08;
  }
  @media (max-width: 576px){
    .profile_logo img{
      width: 200px;
    }
  }
</style>